const setUserIdFB = (id) => {};

const addToCartFB = async (item) => {
  try {
  } catch (error) {}
};

const removeFromCartFB = async (ite) => {
  try {
  } catch (error) {
    alert(error.message);
  }
};

const trackScreenFB = async (route) => {
  try {
  } catch (error) {}
};

const initCrashlytics = async (user) => {
  // todo track device ID
  try {
  } catch (error) {}
};

const reportCrash = async (error: Error, userId: string, meta?: any) => {};

export {
  setUserIdFB,
  addToCartFB,
  removeFromCartFB,
  trackScreenFB,
  initCrashlytics,
  reportCrash,
};
